import { createFileRoute } from '@tanstack/react-router'

import { ReferralPageSkeleton } from '#/modules/referral/front-office/referral-page/referral-page-skeleton.tsx'
import { ReferralPage } from '#/modules/referral/front-office/referral-page/referral-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/referrals/')({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
  // No loader: the referral dashboard, payout IBAN and broker-client status all load through shared
  // non-suspense hooks that self-gate in-component (as on the home screen). The broker-client status
  // reads the contracts cache already warmed by the _shell loader, so the gate resolves without a flash.
  pendingComponent: ReferralPageSkeleton,
  pendingMs: 150,
  component: ReferralPage,
})
